/**
 * dom.js — small browser helpers shared by the Daily Ops screens.
 */

/**
 * Keep a focused text field visible above the on-screen keyboard (esp. iPad, where
 * the keyboard eats ~half the height). Runs after the keyboard's open animation and
 * centres the field in the (keyboard-shrunk) viewport. `onFocus={keepInView}`.
 */
export const keepInView = e => {
  const el = e.currentTarget;
  setTimeout(() => { try { el.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch { /* older browsers */ } }, 300);
};

/**
 * Print only the open modal's `.do-print__doc` — scoped via `body.do-printing`
 * so the rest of the app (and other pages) never get dragged into the printout.
 * Shared by every Daily Operations sheet that offers a 🖨 Print action.
 */
export function printScoped() {
  document.body.classList.add('do-printing');
  const cleanup = () => {
    document.body.classList.remove('do-printing');
    window.removeEventListener('afterprint', cleanup);
  };
  window.addEventListener('afterprint', cleanup);
  window.print();
  setTimeout(cleanup, 1500);
}
